import { ContactCounselorFormModel } from './../modals/contact_counselor/contact_counselor_form_model';
import { ICommand, IQuery, IDefineCommand, IQueryMediator } from 'core-ts-types';

angular.module('capability-ng-global').factory(
  'applicationResetCommand',
  (
    defineCommand: IDefineCommand,
    contactCounselorFormModel: ContactCounselorFormModel,
    $q: ng.IQService,
    clearTransferDatasourcesCommand: ICommand,
    clearChecklistDatasourcesCommand: ICommand
  ): ICommand => {
    return defineCommand('applicationResetCommand', function resetLocalAccountCommand(
      deferred: ng.IDeferred<IQuery[]>
    ): void {
      contactCounselorFormModel.reset();
      $q.all([clearTransferDatasourcesCommand(), clearChecklistDatasourcesCommand()])
        .then(() => {
          deferred.resolve();
        })
        .catch(deferred.reject);
    });
  }
);



// WEBPACK FOOTER //
// ./app/lib/global/commands/application_reset_command.ts